var _rect, _rect2, _rect3, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7311_18466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7311_18466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7311_18466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7311_18466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7311_18466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 43,
    height: 44
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.34375,
    y: 3.57031,
    width: 42.2152,
    height: 43.1023,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7311_18466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4607 21.0901C25.2609 21.0901 27.5391 18.9302 27.5391 16.2755C27.5391 13.6207 25.2609 11.4609 22.4607 11.4609C19.6606 11.4609 17.3824 13.6207 17.3824 16.2755C17.3824 18.9302 19.6606 21.0901 22.4607 21.0901Z",
    fill: "#233D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1705 10.7049C20.2482 10.8568 19.2789 10.2172 19.2789 9.28256C19.2789 7.59046 20.7257 6.21875 22.5105 6.21875C24.2953 6.21875 25.7422 7.59046 25.7422 9.28256C25.7422 10.2172 24.7728 10.8568 23.8506 10.7049C23.4151 10.6331 22.9674 10.5956 22.5105 10.5956C22.0537 10.5956 21.606 10.6331 21.1705 10.7049Z",
    fill: "#233D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4629 45.7702C24.5027 45.7702 26.1562 44.2025 26.1562 42.2687V34.9156C26.1562 32.9818 24.5027 31.4141 22.4629 31.4141C20.4232 31.4141 18.7696 32.9818 18.7696 34.9156V42.2687C18.7696 44.2025 20.4232 45.7702 22.4629 45.7702Z",
    fill: "#233D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01681 4.26094H13.2293C13.6826 4.26094 14.1164 4.44633 14.4186 4.77375L16.2493 6.75731C16.514 7.04407 16.6609 7.41997 16.6609 7.81019C16.6609 9.22341 14.9262 9.90158 13.9678 8.86307L13.018 7.83403C12.6962 7.48536 12.2433 7.28706 11.7689 7.28706H8.01681C7.15165 7.28706 6.43181 6.61953 6.43181 5.774C6.43181 4.92847 7.15165 4.26094 8.01681 4.26094Z",
    fill: "#233D7A",
    stroke: "#083050",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5101 4.77375C30.8123 4.44633 31.2461 4.26094 31.6994 4.26094H36.9119C37.777 4.26094 38.4969 4.92846 38.4969 5.774C38.4969 6.61953 37.777 7.28706 36.9119 7.28706H33.1598C32.6854 7.28706 32.2325 7.48536 31.9107 7.83403L30.9609 8.86307C30.0024 9.90158 28.2678 9.22341 28.2678 7.81019C28.2678 7.41997 28.4147 7.04407 28.6794 6.75731L30.5101 4.77375Z",
    fill: "#233D7A",
    stroke: "#083050",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9106 21.522C15.9106 20.0342 14.7818 18.7812 13.2265 18.5427C12.5349 18.4367 12.4507 17.5867 13.0172 17.1761C13.6852 16.6919 14.4341 16.3141 15.2328 16.0599C15.6644 15.9225 16.0617 16.3058 16.0617 16.7587C16.0617 20.1137 18.9407 22.8431 22.4794 22.8431C26.0182 22.8431 28.8972 20.1137 28.8972 16.7587C28.8972 16.3047 29.2951 15.9203 29.7278 16.0578C32.7522 17.0189 34.9375 19.7307 34.9375 22.9175C34.9375 23.6963 34.8058 24.4657 34.546 25.2046L31.0375 35.1834C30.8731 35.6511 30.6229 36.0741 30.3068 36.439C29.2889 37.6139 27.7646 36.4234 27.7646 34.869C27.7646 32.106 25.3937 29.8582 22.4794 29.8582C19.565 29.8582 17.1941 32.106 17.1941 34.869C17.1941 36.4234 15.6699 37.6138 14.652 36.439C14.3359 36.074 14.0857 35.651 13.9212 35.1833C13.6542 34.4239 13.8011 33.5898 14.2168 32.9005C15.3028 31.0994 15.9106 29.0254 15.9106 26.8493V21.522Z",
    fill: "#233D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4268 22.8431C18.888 22.8431 16.009 20.1137 16.009 16.7587C16.009 16.3047 15.6111 15.9203 15.1785 16.0578C12.1541 17.0189 9.96875 19.7307 9.96875 22.9175C9.96875 23.6963 10.1004 24.4657 10.3602 25.2046L13.8687 35.1834C14.0331 35.6511 14.2833 36.0741 14.5995 36.439C15.6173 37.6139 17.1416 36.4234 17.1416 34.869C17.1416 32.106 19.5125 29.8582 22.4269 29.8582C35.2323 29.8582 32.7596 22.8431 22.4268 22.8431Z",
    fill: "#233D7A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8796 25.2128C42.1267 25.2128 47.1733 20.0451 47.1733 13.6923C47.1733 7.33961 42.1267 2.17188 35.8796 2.17188C29.6325 2.17188 24.5859 7.33961 24.5859 13.6923C24.5859 20.0451 29.6325 25.2128 35.8796 25.2128Z",
    fill: "#FF5A5F",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.203 12.8607L40.2295 13.8831C39.3772 14.7782 38.9866 16.0171 39.1713 17.2392L39.3727 18.5718C39.3876 18.6703 39.3998 18.7711 39.3754 18.8677C39.3711 18.8846 39.3661 18.9016 39.3604 18.9184C39.3014 19.0924 39.1267 19.208 38.9431 19.208C38.8015 19.208 38.6866 19.1028 38.5633 19.0332L37.875 18.6445C36.6544 17.9553 35.1621 17.9553 33.9415 18.6445L33.0672 19.1382C33.0219 19.1627 32.9686 19.1786 32.913 19.1829C32.6949 19.1997 32.4929 19.0068 32.4403 18.7945C32.4164 18.6978 32.429 18.6005 32.4438 18.502L32.6452 17.1694C32.83 15.9473 32.4393 14.7085 31.587 13.8133L30.6135 12.791C30.5653 12.739 30.5351 12.6869 30.5162 12.6313C30.4458 12.4245 30.5131 12.1474 30.7083 12.0493C30.7769 12.0147 30.8454 12.0179 30.9214 12.0061L31.8303 11.8659C33.1659 11.6598 34.3071 10.7932 34.8644 9.56195L35.3917 8.39675C35.5208 8.11775 36.0374 8.11775 36.1665 8.39675L36.6939 9.56195C37.2511 10.7932 38.3924 11.6598 39.728 11.8659L40.4478 11.9769C40.6497 12.0081 40.8719 12.012 41.0246 12.1476C41.2332 12.3328 41.3709 12.6794 41.203 12.8607Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellBike);
export default __webpack_public_path__ + "static/media/sell-bike.6583b587ca54ac94998d172997577209.svg";
export { ForwardRef as ReactComponent };